import { sendAnalytics } from './send-analytics';
import { GAEventMapper } from './types';

type AnalyticsEventMappers<T> = GAEventMapper<T>;
export const createAnalyticsEvent =
  <T = void>(mapper: AnalyticsEventMappers<T>) =>
  (data: T) => {
    sendAnalytics({ ...mapper(data) });
  };
